module.exports = __webpack_public_path__ + "img/bank-20-sh.daf7fdc1.svg";